/**
 * 내 기계 허브 출력 보기(SR-RUN-03 · FS-03 · FS-04) — 커널 이벤트를 넣으면 {@link HubView} 를 준다. 소리 표시는 잠깐 뒤 스스로 지운다.
 */
import { useCallback, useEffect, useRef, useState } from "react";
import type { KernelEvent } from "@picnic-field/local-host/protocol";
import { HUB_BEEP_SHOW_MS, HUB_IDLE, onHubEvent, type HubView } from "../lib/hubOutput";

export function useHubView(): {
  hub: HubView;
  now: number;
  onEvent: (e: KernelEvent) => void;
  reset: () => void;
} {
  const [state, setState] = useState<{ hub: HubView; now: number }>({ hub: HUB_IDLE, now: 0 });
  const timer = useRef<number | null>(null);
  useEffect(
    () => () => {
      if (timer.current !== null) window.clearTimeout(timer.current);
    },
    [],
  );
  const onEvent = useCallback((e: KernelEvent) => {
    if (e.type !== "hub" || e.owner !== "me") return;
    const now = performance.now();
    setState((s) => ({ hub: onHubEvent(s.hub, e, now), now }));
    if (e.beep === true) {
      if (timer.current !== null) window.clearTimeout(timer.current);
      timer.current = window.setTimeout(() => {
        timer.current = null;
        setState((s) => ({ ...s, now: performance.now() }));
      }, HUB_BEEP_SHOW_MS);
    }
  }, []);
  const reset = useCallback(() => setState({ hub: HUB_IDLE, now: 0 }), []);
  return { hub: state.hub, now: state.now, onEvent, reset };
}
